import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { getPaymentEnvironment } from "@/lib/stripe";
import { createBillingPortalSession } from "@/utils/payments.functions";

/**
 * Shown while a renewal payment is failing. The customer keeps Pro access
 * during the retry window — we just prompt them to fix their payment method.
 */
export function PastDueBanner() {
  const { subscriptionStatus } = useAuth();
  const [loading, setLoading] = useState(false);

  if (subscriptionStatus !== "past_due") return null;

  const openPortal = async () => {
    setLoading(true);
    try {
      const result = await createBillingPortalSession({
        data: { environment: getPaymentEnvironment(), origin: window.location.origin },
      });
      if (result?.updatePaymentUrl || result?.url) {
        window.open((result.updatePaymentUrl ?? result.url) as string, "_blank");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full bg-destructive/10 border-b border-destructive/30 px-4 py-2 text-center text-sm text-ink flex flex-wrap items-center justify-center gap-2">
      <AlertTriangle className="size-4 text-destructive" aria-hidden="true" />
      <span>
        We couldn't process your last payment. Your Pro access stays on while we retry.
      </span>
      <button
        onClick={openPortal}
        disabled={loading}
        className="underline font-semibold text-destructive disabled:opacity-60"
      >
        {loading ? "Opening..." : "Update payment method"}
      </button>
    </div>
  );
}